import { setCurrentPage, setItemsPerPage } from "../EmployeeSlice";
import { EmptyListNotice, Table } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useGetEmployeesQuery } from "../../../common/api/employee";
import Skeleton from "react-loading-skeleton";
import { mapEmployeeDataToRow } from "../utils/mapEmployeeDataToRow";
import ellipsisImage from "../../../common/images/ellipsis.svg";
import ellipsisWhiteImage from "../../../common/images/ellipsis-white.svg";
import { useNavigate } from "react-router";
import React, { JSX, useEffect } from "react";
import { useEstablishmentId } from "../../../common/utils/useEstablishmentId";
import { getEmployeeTableHeadColumns } from "../utils/getEmployeeTableHeadColumns";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";

export const EmployeeTable = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const establishmentId = useEstablishmentId();
    const employeeId = useEmployeeId();

    const {
        currentPage,
        searchTerm,
        itemsPerPage,
        itemsPerPageSelect,
        statusFilter,
        functionGroupFilter,
        sort,
    } = useAppSelector((state) => state.employee);

    const {
        data: employeesData,
        isLoading,
        isFetching,
    } = useGetEmployeesQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        sort: sort.sortName,
        filter: {
            search: searchTerm,
            establishment_id: establishmentId,
            status: statusFilter ? statusFilter.value : "",
            ...(functionGroupFilter
                ? { function_group_id: Number(functionGroupFilter.value) }
                : {}),
        },
    });

    useEffect(() => {
        if (
            employeesData &&
            employeesData.data.length === 0 &&
            currentPage > 1
        ) {
            dispatch(setCurrentPage(1));
        }
    }, [employeesData, currentPage, dispatch]);

    if (isLoading || isFetching) {
        return (
            <Skeleton
                height={"60rem"}
                borderRadius={"1.5rem"}
                style={{ marginTop: "3.2rem" }}
            />
        );
    }

    if (!employeesData?.data?.length) {
        return (
            <EmptyListNotice content={"Er zijn geen medewerkers gevonden"} />
        );
    }

    return (
        <section className={"p-employee__table"}>
            <Table
                isPagination={true}
                data={{
                    columns: getEmployeeTableHeadColumns({
                        sort,
                        dispatch,
                    }),
                    rows: mapEmployeeDataToRow({
                        employeesData: employeesData.data,
                        navigate,
                        dispatch,
                        employeeId,
                    }),
                    total: employeesData.meta?.total ?? 0,
                }}
                itemsPerPage={employeesData.meta?.per_page ?? 0}
                itemsPerPageSelect={itemsPerPageSelect}
                onItemsPerPageChange={(
                    event: React.ChangeEvent<HTMLSelectElement>,
                ) => dispatch(setItemsPerPage(Number(event.target.value)))}
                currentPage={currentPage}
                onPaginationChange={(page: number) =>
                    dispatch(setCurrentPage(page))
                }
                iconButtonIconUrl={ellipsisImage}
                iconButtonBackgroundColor={"rgb(243, 244, 246)"}
                onOpenIconButtonUrl={ellipsisWhiteImage}
                onOpenIconButtonBackgroundColor={"#1D2D58"}
            />
        </section>
    );
};
